var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.options),function(option){return _c('li',{key:option.id},[_c('CategoryFilterOption',{attrs:{"active":_vm.attributeIds.includes(option.id),"image":option.image},on:{"click":function($event){return _vm.handleInputChange(option.id)}}},[_vm._v("\n                "+_vm._s(option.name)+"\n            ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }